module.exports = __webpack_public_path__ + "img/googlePlayBg.3ecf84d9.png";